window.satsNormalizeSearchTerm = function (term) {
  if (!term) return '';

  return term.replace(
    /\b(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)(?:\s*[x×]\s*(\d+(?:\.\d+)?))?\s*(mm|cm)?\b/gi,
    (match, widthValue, heightValue, thicknessValue, unitValue) => {
      let width = Number(widthValue);
      let height = Number(heightValue);
      let thickness = thicknessValue ? Number(thicknessValue) : null;
      const unit = (unitValue || '').toLowerCase();
      const maxDimension = Math.max(width, height);
      const minDimension = Math.min(width, height);

      // Canonical Shopify Size is always centimetres. Explicit mm always converts.
      // For unitless searches, dimensions that clearly look millimetre-coded
      // (e.g. 600x600, 595x1200, 170x520) are converted to cm.
      const looksLikeMillimetres =
        unit === 'mm' ||
        (unit === '' && maxDimension >= 300 && minDimension >= 100);

      if (looksLikeMillimetres) {
        width /= 10;
        height /= 10;
        if (thickness !== null && thickness >= 10) thickness /= 10;
      }

      const format = (value) => String(Number(value));
      return `${format(width)}x${format(height)}${thickness !== null ? `x${format(thickness)}` : ''}`;
    }
  );
};

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onSatsSearchSubmit.bind(this), true);
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onSatsSearchSubmit() {
    const normalized = window.satsNormalizeSearchTerm(this.input.value.trim());
    if (normalized) this.input.value = normalized;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// PredictiveSearch is loaded later in the theme. Once defined, make it use
// exactly the same normalizer so typed suggestions and submitted searches agree.
customElements.whenDefined('predictive-search').then(() => {
  const PredictiveSearchElement = customElements.get('predictive-search');
  if (PredictiveSearchElement) {
    PredictiveSearchElement.prototype.normalizeSizeSearchTerm = function (term) {
      return window.satsNormalizeSearchTerm(term);
    };
  }
});